import { styled } from '@mui/material/styles';
import {Box, TextField, Typography} from "@mui/material";

export const TextBox = styled(TextField)({
    width: '100%',
    margin: '1rem 0',
});
